import * as React from 'react';

import PropTypes from 'prop-types';
import { compose } from 'recompose';

import connectToStores from 'js/lib/connectToStores';
import fullStory from 'js/lib/fullStoryUtils';
import Retracked from 'js/lib/retracked';

import MutinyTag from 'bundles/ent-website/components/head/MutinyTag';
import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';
// The "Need to pay by invoice? Chat with our sales team" link is removed by https://coursera.atlassian.net/browse/HP-96
// See "componentDidMount()" for details
// import insertDriftChatBot from 'bundles/growth-upsell/drift/driftChat';
import ApplicationStoreClass from 'bundles/ssr/stores/ApplicationStore';
import TeamsContainer from 'bundles/teams-v2/components/TeamsContainer';
import TeamsMainApp from 'bundles/teams-v2/components/TeamsMainApp';
import { initPendo } from 'bundles/teams-v2/utils/pendo';

import 'css!../styl/index';

type Props = {
  requestCountryCode?: string;
  csrfToken?: string;
};

class TeamsApp extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    getStore: PropTypes.func.isRequired,
  };

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  getChildContext() {
    const { csrfToken, requestCountryCode } = this.props;

    return {
      csrfToken,
      requestCountryCode,
    };
  }

  componentWillMount() {
    const { router } = this.context;

    if (router.location.pathname === '/purchase') {
      router.push({
        pathname: '/purchase/plan',
      });
    }
  }

  componentDidMount() {
    /*
      The "Need to pay by invoice? Chat with our sales team" link is removed by https://coursera.atlassian.net/browse/HP-96
      As of 2023-01-25, there's no plan to revive this link.
      If this is needed again, please revive this line, as well as the `<TeamsbillingInvoiceOffer />`component in the `BillingInfo.tsx`.
    */
    /*
    insertDriftChatBot(window);
    */

    const isFreeTrial = EnterpriseExperiments.get('enableFreeTrial');
    fullStory.init();
    fullStory.set({
      isFreeTrial,
    });

    initPendo();
  }

  render() {
    const { children } = this.props;

    return (
      <TeamsContainer>
        <MutinyTag />
        <TeamsMainApp>{children}</TeamsMainApp>
      </TeamsContainer>
    );
  }
}
export default compose<Props, {}>(
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        app: 'teams_v2',
        page: 'teams_v2_page',
      },
    };
  }),
  connectToStores<Props, {}>([ApplicationStoreClass], (ApplicationStore, props) => ({
    ...props,
    csrfToken: ApplicationStore.getState().csrfToken,
    requestCountryCode: ApplicationStore.getState().requestCountryCode,
  }))
)(TeamsApp);
